import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-results-kpi',
    templateUrl: './results-kpi.component.html',
    styleUrls: ['./results-kpi.component.scss'],
    standalone: false,
})
export class ResultsKpiComponent {
    @Input() kpiTitle = '';
    @Input() kpiSubtitle = '';
    @Input() kpiValue = '';
    @Input() kpiPlaneValue = '';
    @Input() kpiTreeValue = '';
    @Input() kpiFillUpValue = '';
    @Input() kpiUnit = '';
    @Input() showInfoIcon = '';
    @Input() showLink = '';
    @Input() contentInfoIcon = '';
    @Input() appearance: 'default' | 'compact' = 'default';
}
